import { render } from "./ScHelpWidget.vue?vue&type=template&id=79dc3d45&scoped=true"
import script from "./ScHelpWidget.vue?vue&type=script&lang=js"
export * from "./ScHelpWidget.vue?vue&type=script&lang=js"

import "./ScHelpWidget.vue?vue&type=style&index=0&id=79dc3d45&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dc3d45"]])

export default __exports__